import React from 'react';
import styled from 'styled-components';

const MinerHash = styled.div`
  font-size: 10px;
  font-weight: 500;
  color: #8399B8;
  line-height: 12px;
  padding-bottom: 5px;
  cursor: pointer;
`;

export default MinerHash;
